module.exports = __webpack_public_path__ + "static/media/menu11.7246b149.jpg";